import { RG_TYPE } from '../../types/rg-type.js';

const DefaultCeiling = {
    type: RG_TYPE.Ceiling,
    size: [6, 0.145, 6],
    anchor: [0.5, 1, 0.5],
    pos: [0, 3, 0],
    name: 'ceiling',
    children: [],
    color: '#5EA0BB',
    modulousId: 'CPA|05|'
};

export { DefaultCeiling };
//# sourceMappingURL=default-ceiling.js.map
